const Landing: React.FC = () => {
    return <>Landing</>;
};

export default Landing;
